var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9857 8.95639C16.8828 5.26605 13.7338 3.33352 10.5013 3.3335C7.26866 3.33347 4.11969 5.26596 2.01679 8.9563C1.64805 9.60341 1.64805 10.3968 2.01679 11.0439C4.11968 14.7342 7.26866 16.6667 10.5012 16.6668C13.7338 16.6668 16.8828 14.7343 18.9857 11.044C19.3545 10.3969 19.3545 9.6035 18.9857 8.95639ZM10.1273 7.41219L9.451 8.76483C9.41068 8.84546 9.3453 8.91085 9.26466 8.95117L7.91202 9.62748C7.60492 9.78104 7.60492 10.2193 7.91202 10.3728L9.26466 11.0492C9.3453 11.0895 9.41068 11.1549 9.451 11.2355L10.1273 12.5881C10.2809 12.8952 10.7191 12.8952 10.8727 12.5881L11.549 11.2355C11.5893 11.1549 11.6547 11.0895 11.7353 11.0492L13.088 10.3728C13.3951 10.2193 13.3951 9.78104 13.088 9.62749L11.7353 8.95117C11.6547 8.91085 11.5893 8.84546 11.549 8.76483L10.8727 7.41219C10.7191 7.10508 10.2809 7.10508 10.1273 7.41219Z",
    fill: "#0F55DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.2875d2d096300461a3542230f521b8c2.svg";
export { ForwardRef as ReactComponent };